module.exports = __webpack_public_path__ + "img/ic_meat_white.9a42d28b.svg";